/** @module SiteAdmin/ProjectForm */
define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/config",
    "csi/def/Field",
    "csi/reflection",
    "csi/xml",
    "csi/form/Widget"
], function(declare,lang,config,Field,reflection,xml,Widget) {
    return declare(Widget, {

		SUBTYPE: "Subtype",

		/**
		 * Return true if there is any Active ProjectSubtype ProjectSubtypeSettings
		 */
		_hasActiveProjectSubtype: function() {
			const classType = this.defView.getRootClass().getType();
			return config.hasSubtype(classType);
		},

		/**
		 * summary: insert field for "Subtype" if there is any Active ProjectSubtype
		 */
		_insertSubtypeField: function() {

			this.insertField(lang.mixin(new Field(), {
				m_id: this.SUBTYPE
			}), 0);
		},

		_resolveView: function() {
			//this.getfield if exists dont call this._insertif()
			if(!this.defView.getField(this.SUBTYPE))
			{
				this._insertSubtypeField();
			}
			this.inherited(arguments);
		}
	});
});